<template>
  <div class="index">
    <vuescroll :ops='vuescrollOption'>
      <div class='banner'>
        <img src="@/assets/images/index/bannerBg.jpg" class="bg">
        <div class='downloadBT'>
          <img src="@/assets/images/index/googleBT.png" @click='tipsText="敬請期待"' class="googleBT">
          <img src="@/assets/images/index/iphoneBT.png" @click='tipsText="敬請期待"' class="iphoneBT">
        </div>
      </div>
      <div class="content">
        <div class='breadcrumb'>
          <div class="left">
            您目前的位置：<router-link to="/index">首頁</router-link>> 常見問題
          </div>
          <div class="right">
            <router-link to="/index">
              <img src="@/assets/images/article/returnHome.png">
            </router-link>
          </div>
        </div>
        <div class='titleDiv'>
          <div class="title">
            常見問題
          </div>
          <div class="time">
            2021-09-01 18:00:13
          </div>
        </div>
        <div class='contentText'>
          <table cellspacing="0" cellpadding="0">
            <tr>
              <td rowspan="9">遊戲玩法：城鎮建設</td>
              <td>貓頭鷹訂單簡介</td>
              <td>
                <div>點擊小貓頭鷹所在的建築，就可以打開訂單板!</div>
                <div>訂單是收入金幣和遊戲經驗的最重要來源之一! </div>
                <div>注意：金色的鋸子、鑿子和錘子只能從默林訂單中獲得! </div>
                <div>你可以按紅色的刪除按鈕刷新你不喜歡的訂單。</div>
              </td>
            </tr>
            <tr>
              <td>火車站簡介</td>
              <td>火車站是童話世界中運送貨物的重要管道。隨著角色等級的提高，你最多可以獲得3輛火車。使用對應的材料完成火車訂單可以獲得稀有的建築材料哦~</td>
            </tr>
            <tr>
              <td>收藏簡介</td>
              <td>收藏室展示了你所有的冒險收藏品! 收集收藏品還可以獲得大量的獎勵! 收藏品可以通過冒險的寶箱獲得!</td>
            </tr>
            <tr>
              <td>為什麼有些建築物無法移動？</td>
              <td>冒險地圖中的固有建築物是不可移動的。火車站的位置在你的家園是固定的，不能移動。有些建築需要你達到一定的等級才可以移動或解鎖。正在工作的建築不能被移動。</td>
            </tr>
            <tr>
              <td>如何規劃城市？</td>
              <td>你可以按住你的建築轉換為編輯模式，然後你就可以隨意移動和旋轉你的建築，直到你滿意為止。你也可以點擊錢包圖示來拆除建築並出售，但我們不建議這樣做，因為建造的成本比拆除的成本要高得多！</td>
            </tr>
            <tr>
              <td>貨物填充券是什麼？</td>
              <td>貨物填充券可以用來填充火車的車廂! 當你覺得很難獲得目標資源時，使用優惠券是個不錯的選擇。</td>
            </tr>
            <tr>
              <td>如何出售建築？</td>
              <td>要出售建築，你需要點擊並按住你想出售的建築，當它變成綠色後，在螢幕的底部，你會看到一個選單，選擇錢的圖示。注意，不是所有的建築都可以出售；有些建築很重要，因此無法出售。</td>
            </tr>
            <tr>
              <td>人口不足怎麼辦？</td>
              <td>鎮上的村民會來幫助你生產貨物，但你需要先為他們提供一個住所。不同種類的房子可以容納不同數量的人口。建造更多的房子來招募更多的幫手!</td>
            </tr>
            <tr>
              <td>缺乏某種資源怎麼辦？</td>
              <td>如果你在製作產品或完成任務時需要某些特定資源，點擊任務板上的問號按鈕，系統會在附近地區搜索這些資源。另外當你在冒險地圖中時，也不要忘記收集有價值的資源。</td>
            </tr>
            <tr>
              <td rowspan="6">遊戲玩法：冒險地圖</td>
              <td>如何在地圖中打開雲層？</td>
              <td>採集雲層周圍的資源即可打開雲層。部分雲層在完成特定任務之前是不能打開的哦~</td>
            </tr>
            <tr>
              <td>如何開啟一些障礙物？</td>
              <td>有些大門需要特製的鑰匙或者滿足某些條件後才可以打開的。部分障礙物在完成特定任務之前是無法清理的。</td>
            </tr>
            <tr>
              <td>如何回到家園？</td>
              <td>如果您在探索地圖中，首先點擊右下角的地圖按鈕；然後在彈出界面點擊左下角的“家園“即可回到家園</td>
            </tr>
            <tr>
              <td>如何查看被遮住的物體？</td>
              <td>點擊右上角設置後面的”三角形“按鈕，之後會發現一個樹的圖示。點擊該圖示，部分被遮擋的物體就可以查看/採集了。</td>
            </tr>
            <tr>
              <td>找不到前進的方向怎麼辦？</td>
              <td>請查看周圍是否有未開採的資源；您也可以根據任務指引繼續前進。點擊？按鈕，可以起到事半功倍的效果。</td>
            </tr>
            <tr>
              <td>如何找到商人？</td>
              <td>商人遊走於世界各個地圖之中。一般來講，每張探索地圖之中都可以找到商人。找到商人後，您可以跟他交換一些道具。</td>
            </tr>
            <tr>
              <td rowspan="2">解決問題</td>
              <td>遊戲總是崩潰/卡死怎麼辦？</td>
              <td>
                <div>如果您的遊戲經常崩潰或當機，請嘗試以下故障排除步驟： </div>
                <div>對於 iOS 設備：</div>
                <div>1. 確保您從 App Store 下載了最新版本的遊戲。如果您使用的是越獄設備，我們無法保證遊戲的穩定性和高性能。</div>
                <div>2. 確保您的網路連接穩定並嘗試使用不同類型的網路（Wi-Fi 或移動網路）。</div>
                <div>3.嘗試關閉其他應用程式。為此，您需要滑動除關閉 Fairy Town 之外的所有其他應用程式。</div>
                <div>4.檢查設備的存儲容量：打開設置>>關於檢查可用容量。通過刪除未使用的應用程式、圖片和視頻來釋放空間。</div>
                <div>5.如果遊戲要求您發送崩潰報告，請這樣做，這對我們解決問題有很大幫助！</div>
                <div>對於 Android 設備：</div>
                <div>1. 確保您從 Google Play下載了最新版本的遊戲。如果您從其他網站下載遊戲，我們無法保證遊戲的穩定性和高性能。</div>
                <div>2. 確保您的網路連接穩定並嘗試使用不同類型的網路（Wi-Fi 或移動網路）。</div>
                <div>3. 嘗試在玩遊戲時強制停止所有不必要的應用程式。</div>
                <div>4.嘗試清除設備上的遊戲緩存：打開設置>>應用>>Fairy Town>>然後點擊清除緩存按鈕（不要與清除數據混淆）。</div>
                <div>5.如果遊戲要求您發送崩潰報告，請這樣做，這對我們解決問題有很大幫助！</div>
              </td>
            </tr>
            <tr>
              <td>如何聯繫客服？</td>
              <td>
                <div>1. 點擊設置-幫助與支持-我要提問-選擇對應的問題類型並進行描述。之後提交即可。</div>
                <div>2. 您也可以通過Facebook粉絲頁給我們留言。我們將在24小時之內解決您的問題。</div>
              </td>
            </tr>
            <tr>
              <td rowspan="5">常用問題</td>
              <td>這是一款什麼遊戲？</td>
              <td>
                <div>Fairy Town是一款浪漫的城鎮建設和農業生產遊戲！ 製作各種補給品和魔法物品，讓您的城鎮保持幸福和繁榮。</div>
                <div>在您的農場飼養雞、牛，甚至是魔法生物！</div>
                <div>探索神秘的仙境，與睡美人、白雪公主和小紅帽成為朋友。</div>
                <div>準備好迎接冒險中的挑戰、謎語和寶藏，尋找真理和財富！</div>
                <div>探索神奇的森林、神秘的海底世界、壯麗的雪山，以及仙境中許多其他未知的地方。</div>
                <div>在一款遊戲中體驗市長、農民、冒險家、魔術師和童話人物的生活！</div>
              </td>
            </tr>
            <tr>
              <td>如何修改昵稱？</td>
              <td>點擊設置並選擇“筆”圖示，然後輸入您的昵稱。 並非所有名稱都被系統接受，如果您選擇的用戶名沒有通過，請創建一個更好的名稱！</td>
            </tr>
            <tr>
              <td>如何修改頭像？</td>
              <td>點擊頭像，選擇您喜歡的頭像，之後點擊”更換“即可。</td>
            </tr>
            <tr>
              <td>如何更新遊戲？</td>
              <td>
                <div>您可以直接在遊戲內搜索Fairy Town來查看是否有更新的版本。</div>
                <div>您也可以在商店中，根據提示打開應用自動升級來獲取更新。</div>
              </td>
            </tr>
            <tr>
              <td>為何要更新遊戲至最新版？</td>
              <td>我們會在更新包中發佈新的故事線地點和活動，並根據你的回饋改進技術和修復錯誤。所以所有玩家需要更新到最新版本。謝謝您的理解。</td>
            </tr>
            <tr>
              <td rowspan="8">支付相關</td>
              <td>支付後未收到物品怎麼處理？</td>
              <td>網路連接問題可能導致您延遲收到購買的物品。請先檢查您的網路連接。如果您的網路連接穩定，嘗試重啟您的設備，確定購買物品是否收到。如果您依然沒有收到物品，請聯繫我們並提供相應的購買收據。我們的團隊會儘快幫助您。您可以線上獲取收據： - 訪問 pay.google.com/。 - 使用您的 Google 帳戶登錄。 - 在左側，單擊活動。 - 要獲取您的收據，請選擇對應的訂單。</td>
            </tr>
            <tr>
              <td>如何獲取充值的收據？</td>
              <td>在 Google 商店購買商品後，您會收到一封確認電子郵件，可用作收據。 您可以在此收據上找到您的訂單號。</td>
            </tr>
            <tr>
              <td>如何購買應用內商品？</td>
              <td>購買由商店處理，因此您應該使用 商店支持的付款方式。</td>
            </tr>
            <tr>
              <td>未經我授權的交易，怎麼處理？</td>
              <td>
                <div>如果您有理由相信有人在您不知情的情況下進行了購買，請查看您在 Google Play 中的購買記錄。</div>
                <div>如果您確定在我們的某款遊戲中進行了未經授權的購買，請直接從遊戲設置中聯繫我們。</div>
                <div>請確保提供所有必要的詳細資訊，包括：</div>
                <div>- 購買商品的確切數量。</div>
                <div>- 您的收據副本或您在應用商店中的購買歷史截圖。收據將通過電子郵件發送到您購買時使用的帳戶。請注意，我們不接受有關提款的銀行對帳單或短信提醒。</div>
                <div>請注意，在您提供詳細的情況描述並附上收據或購買歷史的螢幕截圖之前，我們將無法審核您的請求。</div>
              </td>
            </tr>
            <tr>
              <td>不小心充值到了其他遊戲怎麼辦？</td>
              <td>
                <div>如果您在未安裝的遊戲中為應用內購買付費，請在商店中查看購買記錄。</div>
                <div>如果應用商店把您指向到 ManaGames，請與我們聯繫並附上交易收據副本。</div>
              </td>
            </tr>
            <tr>
              <td>充值歷史怎麼查看？</td>
              <td>您可以前往應用商店查看您的購買歷史記錄。</td>
            </tr>
            <tr>
              <td>如何通過第三方網站儲值？</td>
              <td>
                <div>我們強烈建議您不要通過第三方網站購買任何遊戲內資源（硬幣、助推器等）。</div>
                <div>這些優惠可能會試圖訪問您的個人數據和信用卡資訊。</div>
                <div>請記住，您很可能永遠不會收到購買的資源。</div>
                <div>購買遊戲內資源的唯一安全可靠的方式是直接通過您設備上的應用程式。 從任何其他網站購買遊戲內資源均違反 ManaGames 的使用條款。</div>
              </td>
            </tr>
            <tr>
              <td>為何付款時多扣款了？</td>
              <td>
                <div>在確認付款之前，您可以在螢幕上看到最終價格，也可以在應用商店的收據上看到最終價格。</div>
                <div>在某些地區，您需要支付一部分稅費。 您所在的地區是根據您在應用商店配置檔中選擇的國家/地區自動確定的。</div>
                <div>如果您仍然認為自己被收取了額外費用，請與我們取得聯繫。</div>
              </td>
            </tr>
            <tr>
              <td rowspan="6">新手指南</td>
              <td>如何獲取更多體力？</td>
              <td>除了自動恢復之外，還有其他一些獲取能量的方法。 多注意冒險地圖中灌木叢或森林下的箱子、瓶子、盒子，裏面會找到一些可以用來補充能量的食物或材料。 利用您家中的煉金站、餐車和篝火等建築物來生產能量！ 此外，觀看廣告也可以獲取能量。</td>
            </tr>
            <tr>
              <td>如何獲取炸彈？</td>
              <td>在探險時您有可能發現其他冒險家留下的炸彈，這些炸彈也可以使用! 另外，您也可以消耗綠寶石來購買炸彈!</td>
            </tr>
            <tr>
              <td>如何獲取寶石？</td>
              <td>
                <div>您可以從任務中獲得綠寶石。</div>
                <div>提示：在美人魚花園點擊紅色的柳樹可以獲得一顆綠寶石。觀看廣告也有機會獲得綠寶石哦~</div>
              </td>
            </tr>
            <tr>
              <td>如何獲取金幣？</td>
              <td>您可以通過完成訂單、完成任務、出售背包中的物品和通過碼頭交易獲得金幣。</td>
            </tr>
            <tr>
              <td>體力最大值可以超過當前進度條上限嗎？</td>
              <td>是的，當能量條裝滿時，您仍然可以獲得能量，新獲得的能量在裝滿能量條後會繼續增加，這意味著您可以盡可能多地儲存能量。</td>
            </tr>
            <tr>
              <td>沙漏的用處</td>
              <td>親愛的市長。沙漏可以用來加快牲畜的生產速度。點擊牲畜，即可使用沙漏加快動物生產速度。</td>
            </tr>
          </table>
        </div>  
      </div>
      <div class='foot'>
        <img src="@/assets/images/index/footBg.jpg" class="bg">
        <img src="@/assets/images/index/footLogoLeft.png" class="logoLeft">
        <img src="@/assets/images/index/footLogoRight.png" class="logoRight">
        <div class='article' @click="$router.push('/article')"></div>
        <div class='article1' @click="$router.push('/article1')"></div>
        <!-- <div class='article2' @click="$router.push('/article2')"></div> -->
        <div class='article3' @click="goPage('https://www.facebook.com/FairyTownCindeBella')"></div>
      </div>
    </vuescroll>
  </div>
</template>

<script>
import vuescroll from 'vuescroll';
export default {
  name: 'index',
  components:{
    vuescroll
  },
  data () {
    return {
      vuescrollOption:{
        scrollPanel: {
          initialScrollY: 6.7*parseFloat(document.documentElement.style.fontSize),
        },
      }
    }
  },
  mounted(){
  },
  methods:{
    goPage(href){
      window.location.href=href;
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@fullWidth:19.2rem;

@bannerHeight:872/100rem;
@contectHeight:2162/100rem;
@footHeight:174/100rem;

@googleBTWidth:326/100rem;
@iphoneBTWidth:262/100rem;
@downloadGaps:.5rem;

@newWidth:48/100rem;

@marqueImgWidth:1200/100rem;
.index{
  position: absolute;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  overflow: hidden;
  .banner{
    position: relative;
    width: @fullWidth;
    height: @bannerHeight;
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .downloadBT{
      position: absolute;
      width: @googleBTWidth + @iphoneBTWidth + @downloadGaps;
      left: (@fullWidth - (@googleBTWidth + @iphoneBTWidth + @downloadGaps))/2;
      top: 5.7rem;
      .googleBT{
        position: absolute;
        width: @googleBTWidth;
        right: 0;
        top: 0;
      }
      .iphoneBT{
        position: absolute;
        width: @iphoneBTWidth;
        left: 0;
        top: 0;
      }
    }
  }
  .content{
    margin-left: 3.2rem;
    width: @fullWidth - 6.4rem;
    .breadcrumb{
      margin-top: .35rem;
      margin-bottom: .74rem;
      height:.42rem;
      .left{
        float: left;
        line-height:.42rem;
        font-size:.24rem
      }
      .right{
        float: right;
        font-size:0rem;
        img{
          width:1.32rem;
        }
      }
      a{
        color:#f56b85;
      }
    }
    .titleDiv{
      width:100%;
      height:1.66rem;
      border-top:solid .02rem #ebebeb;
      border-bottom:solid .02rem #ebebeb;
      .title{
        width:100%;
        height:.36rem;
        line-height:.36rem;
        font-size:.36rem;
        color:#ec4828;
        text-align: center;
        margin-top:.5rem;
      }
      .time{
        width:100%;
        height:.24rem;
        line-height:.24rem;
        font-size:.24rem;
        color:#68696b;
        text-align: center;
        margin-top:.18rem;
      }
    }
    .contentText{
      width:@fullWidth - 6.4rem - 2rem;
      line-height:.3rem;
      font-size:.24rem;
      color:#68696b;
      margin-left: 1rem;
      margin-top: .8rem;
      margin-bottom: .8rem;
      table{
        border: solid .01rem #ebebeb;
        width:@fullWidth - 6.4rem - 2rem;
        tr{
          // border: solid .02rem #ebebeb;
          td{
            border: solid .01rem #ebebeb;
            margin:0;
            padding:.07rem;
          }
        }
      }
    }
  }
  .foot{
    position: relative;
    width: @fullWidth;
    height: @footHeight;
    .article{
      position: absolute;
      width: .6rem;
      height:.3rem;
      left:11.4rem;
      top:1.1rem;
      cursor:pointer;
      // background:red;
    }
    .article1{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:12.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:blue;
    }
    .article2{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:13.17rem;
      top:1.1rem;
      cursor:pointer;
      // background:yellow;
    }
    .article3{
      position: absolute;
      width: .85rem;
      height:.3rem;
      left:14.2rem;
      top:1.1rem;
      cursor:pointer;
      // background:green;
    }
    .bg{
      position: absolute;
      width: @fullWidth;
      left: 0;
      top: 0;
    }
    .logoLeft{
      position: absolute;
      width: 3.38rem;
      left: 3.2rem;
      top: .17rem;
    }
    .logoRight{
      position: absolute;
      width: 5.4rem;
      right: 3.2rem;
      top: .17rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/article2.vue